// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"582ccced","654":"7cddfaa1","704":"b8290041","884":"cd44cc7e"}[chunkId] + ".chunk.js";
};